module.exports = __webpack_public_path__ + "static/media/bg4.3f1ad3e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg4.jpg
// module id = 5860
// module chunks = 0